import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchQueryLists, switchMainTab, getConfigRecommendationFilterList, minimizeInsightsTab } from "../../../actions/insightsRecommendationActions";
import ChartPageContainer from "./ChartPage/ChartPageContainer";
import Help from "./HomePage/Help";
import InsightsHomePage from "./HomePage/InsightsHomePage";
import "./InsightsTabContainer.scss";
import AIModal from "./AIModal";
import { ReactComponent as InsightsIconMinimized } from "../../../assets/svg/insights-genie-minimized.svg";
import { ReactComponent as InsightsIconMaximized } from "../../../assets/svg/insights-genie-maximized.svg";
import { ReactComponent as AI_icon } from "../../../assets/svg/AI-icon.svg";

const InsightsTabContainer = (props) => {
    const dispatch = useDispatch();

    const currentPage = useSelector((state) => state.insightsRecommendationReducer.currentPage);

    const brandTopicObj = useSelector((state) => state.insightsRecommendationReducer.ownBrand);
    const competitorTopicObj = useSelector((state) => state.insightsRecommendationReducer.competitorsBrand);
    const minimizeTab = useSelector((state) => state.insightsRecommendationReducer.minimizeTab);
    const [isAIModalOpen, setIsAIModalOpen] = useState(false);
    const [count, setCount] = useState(0);

    useEffect(() => {
        dispatch(fetchQueryLists());
        dispatch(getConfigRecommendationFilterList());

        return () => {
            //on unmount, reset to home page
            // dispatch(switchMainTab("home"));

            dispatch(minimizeInsightsTab(true));
        };
    }, []);

    useEffect(() => {
        if ((brandTopicObj || competitorTopicObj) && currentPage === "help") {
            dispatch(switchMainTab("home"));
        }
    }, [brandTopicObj, competitorTopicObj]);

    const handleMaximizeTab = () => {
        setCount((prev) => prev + 1);

        if (!minimizeTab) dispatch(minimizeInsightsTab(true));
        else {
            dispatch(switchMainTab("home"));
            dispatch(minimizeInsightsTab()); // if empty payload, then false by default
        }
    };

    const toggleAIModal = () => {
        setIsAIModalOpen((prev) => !prev);
    };

    return (
        <>
            {/* <div className="insights__icon--top" onClick={toggleAIModal}>
                <AI_icon />
            </div> */}
            <div className="insights__icon--bottom" onClick={handleMaximizeTab}>
                {minimizeTab ? (
                    <InsightsIconMinimized className={`${count > 0 ? "minimized__icon" : null}`} />
                ) : (
                    <InsightsIconMaximized className="maximized__icon" />
                )}
            </div>

            <AIModal isOpen={isAIModalOpen} onClose={toggleAIModal} />
            <div
                className={`insights__tab_row skiptranslate ${["home", "help"].includes(currentPage) ? "minimise__width" : "dynamic__width"}  ${
                    minimizeTab ? "hide__container" : ""
                }`}>
                {minimizeTab ? null : (
                    // (    <div className="minimized__content">Insights Genie ✨</div>)
                    <>
                        <div className={`insights__tab__container ${["home", "help"].includes(currentPage) ? "home__page" : "dynamic__page"} `}>
                            {currentPage == "help" ? <Help /> : <InsightsHomePage currentPage={currentPage} />}
                        </div>

                        <div className={`insights__tab__container_chart ${["home", "help"].includes(currentPage) ? "hide" : "dynamic__page"}  `}>
                            {currentPage !== "home" && currentPage !== "help" && <>{<ChartPageContainer />}</>}
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default InsightsTabContainer;
